// extracted by css-extract-rspack-plugin
export default {"badge":"NA9_5","hot":"Lr4Gl","new":"uNRlg","top":"qMi9v","hidden":"wLmjT"};